/**
 * Configuration for the per-language example novels.
 *
 * All example novels are owned by the single `ePlotera` Firestore user account.
 * Each supported language maps to a distinct novel document ID so they can hold
 * language-appropriate content.
 *
 * Firestore path pattern:
 *   users/ePlotera/novels/{EXAMPLE_NOVEL_ID_BY_LANG[lang]}
 */

/** The Firestore document ID of the account that owns all example novels. */
export const EXAMPLE_NOVEL_OWNER_ID = 'ePlotera' as const;

/**
 * Maps each supported i18next language code to the novel document ID
 * for that language's example novel.
 */
export const EXAMPLE_NOVEL_ID_BY_LANG: Readonly<Record<string, string>> = {
  en: 'example_I_en',
  es: 'example_I_es',
  ca: 'example_I_ca',
  fr: 'example_I_fr',
  it: 'example_I_it',
  de: 'example_I_de',
} as const;

/** Fallback language when the user's language is not in the map. */
export const EXAMPLE_NOVEL_FALLBACK_LANG = 'en' as const;

/**
 * All example novel document IDs across every language.
 * Used for fast membership checks (e.g. isExampleNovel derivation).
 */
export const ALL_EXAMPLE_NOVEL_IDS: readonly string[] = Object.values(
  EXAMPLE_NOVEL_ID_BY_LANG,
);
